<router-outlet name="lightbox"></router-outlet>
@if (article) {
  <mb-article
    [article]="article"
    [defaultActions]="defaultActions"
    [articleActions]="articleActions"
    [sectionActions]="sectionActions"
  ></mb-article>
}
